import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

const NotReadyModal: ActivityComponentType = () => {
    const { pop } = useFlow();
    return (
        <Modal>
            <ModalContainer>
                <Column spacing={24} align='center'>
                    <Text size='lg' align='center'>
                        Androidアプリは<br/>
                        現在準備中でございます。<br/>
                        今しばらく<br/>
                        お待ちくださいませ。
                    </Text>
                    <Button fullWidth onClick={pop}>
                        閉じる
                    </Button>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default NotReadyModal;
